import { useEffect } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom"; //useNavigate
import Home from "pages/Home";
import Login from "pages/Login";
//import LoginWithEmail from "pages/LoginWithEmail";
import OtpVerification from "pages/OtpVerification";
import PasswordLogin from "pages/PasswordLogin";
import ForgotPassword from "pages/ForgotPassword";
import ChangePassword from "pages/ChangePassword";
import ForceChangePassword from "pages/ForceChangePassword";
import PasswordResetSuccess from "pages/PasswordResetSuccess";
import ProfileUpdate from "pages/ProfileUpdate";

import AppInitializer from "components/AppInitializer";
import DeviceGrantLogin from "pages/DeviceGrantFlow/DeviceGrantLogin";
import DeviceGrantOtpVerification from "pages/DeviceGrantFlow/DeviceGrantOtpVerification";
import DeviceGrantHome from "pages/DeviceGrantFlow/DeviceGrantHome";
import DeviceGrantValidateUserCode from "pages/DeviceGrantFlow/DeviceGrantValidateUserCode";
import DeviceGrantProfileUpdate from "pages/DeviceGrantFlow/DeviceGrantProfileUpdate";
import DeviceGrantComplete from "pages/DeviceGrantFlow/DeviceGrantComplete";
import DeviceGrantPasswordLogin from "pages/DeviceGrantFlow/DeviceGrantPasswordLogin";
import DeviceGrantForgotPassword from "pages/DeviceGrantFlow/DeviceGrantForgotPassword";
import DeviceGrantPasswordResetSuccess from "pages/DeviceGrantFlow/DeviceGrantPasswordResetSuccess";
import DeviceGrantForceChangePassword from "pages/DeviceGrantFlow/DeviceGrantForceChangePassword";
import LoginWithMobile from "pages/LoginWithMobile";
import Layout from "components/Layout";
// import LoginWidget from "components/LoginWidget/LoginWidget";
export function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}

function App(): JSX.Element {
  //const navigate = useNavigate();
  const query = useQuery();
  const clearStorage = query.get("clear") === "1";

  useEffect(() => {
    if (clearStorage) {
      localStorage.clear();
    }
  }, [clearStorage]); // independent call

  return (
    <AppInitializer>
      <Routes>
        {/* Home has its own full-bleed hero background for the
            unauthenticated view — deliberately outside the shared Layout
            wrapper below, which every other route uses (Header/panel/Footer
            chrome). Home should never render that shared chrome. */}
        <Route path="/" element={<Home />} />
        <Route path="/device-grant-flow/home" element={<DeviceGrantHome />} />
        <Route element={<Layout />}>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/login-redirect" element={<LoginRedirect />} /> */}
          {/* <Route path="/login" element={<LoginWidget />} /> */}
          {/*<Route path="/register" element={<Register />} /> */}
          {/* <Route path="/login/callback" element={<LoginCallBack />} /> */}
          {/* <Route path="/loginWithEmail" element={<LoginWithEmail />} /> */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/password/change/:changeId" element={<ChangePassword />} />
          <Route path="/password/force-change/:changeId" element={<ForceChangePassword />} />
          <Route path="/password-reset-success" element={<PasswordResetSuccess />} />
          <Route path="/otp-verification" element={<OtpVerification />} />
          <Route path="/password-login" element={<PasswordLogin />} />
          <Route path="/profile-update" element={<ProfileUpdate />} />
          <Route path="/device-grant-flow/profile-update" element={<DeviceGrantProfileUpdate />} />
          <Route path="/device-grant-flow/login" element={<DeviceGrantLogin />} />
          <Route path="/device-grant-flow/otpVerification" element={<DeviceGrantOtpVerification />} />
          <Route path="/device-grant-flow/home" element={<DeviceGrantHome />} />
          <Route path="/device-grant-flow/validate-user-code" element={<DeviceGrantValidateUserCode />} />
          <Route path="/device-grant-flow/complete" element={<DeviceGrantComplete />} />
          <Route path="/device-grant-flow/password-login" element={<DeviceGrantPasswordLogin />} />
          <Route path="/device-grant-flow/forgot-password" element={<DeviceGrantForgotPassword />} />
          <Route path="/device-grant-flow/password-reset-success" element={<DeviceGrantPasswordResetSuccess />} />
          <Route path="/device-grant-flow/password/force-change/:changeId" element={<DeviceGrantForceChangePassword />} />
          <Route path="/login-with-mobile" element={<LoginWithMobile />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Route>
      </Routes>
    </AppInitializer>
  );
}

export default App;
